<template>
  <div class="login-body">
    <div class="login">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <h1 class="login-title">Resiter</h1>
            <v-text-field
              v-model="email"
              label="Account"
              placeholder="email"
              type="email"
              required
            ></v-text-field>
            <v-text-field
              v-model="password"
              label="Password"
              placeholder="passsword"
              type="password"
              required
            ></v-text-field>
            <v-text-field
              v-model="isPassword"
              label="Confirm"
              placeholder="confirm passsword"
              type="password"
              required
            ></v-text-field>
            <v-text-field
              v-model="nickname"
              label="Name"
              placeholder="nick name"
              type="text"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex justify-end">
            <div class="d-flex flex-column btn-columns">
              <v-btn color="orange" @click="btnLogin" depressed>Register</v-btn>
              <v-btn color="secondary" @click="$router.back()" depressed>Cancel</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import axios from '@/lib/axios'
import qs from 'qs'

export default {
  data() {
    return {
      email: '',
      password: '',
      isPassword: '',
      nickname: ''
    }
  },
  methods: {
    async btnLogin() {
      if (!this.email) {
        this.$message.error('please input email')
        return ''
      }
      if (!this.password) {
        this.$message.error('please input password')
        return ''
      }
      if (!this.isPassword) {
        this.$message.error('please input isPassword')
        return ''
      }
      if (!this.nickname) {
        this.$message.error('please input nickname')
        return ''
      }
      /* axios.defaults.headers['Methods'] = 'POST' */
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + '/wordprison/register/',
          {
            email: this.email,
            password: this.password,
            isPassword: this.isPassword,
            nickname: this.nickname
          },
          {
            withCredentials: true
          }
        )
        .then((response)=>{
          if (response.status === 200) {
            if (response.data.code === 200) {
              this.$store.dispatch('user/sync')
                .then(()=>{
                  this.$router.push('/')
                })
            } else {
              alert(response.data.message)
            }
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    }
  }
}
</script>
<style scoped>
.btn-columns .v-btn{
  margin-bottom: 0.8rem;
}
.login-body {
  padding-top: 100px;
  width: 100%;
  height: 100%;
}
.login {
  margin: 0 auto;
  max-width: 500px;
  border: 1px solid #fdc660;
}
.login-title {
  text-align: center;
  margin-top: 20px;
}
</style>
